<!-- ======= Sidebar ======= -->
<aside id="sidebar" class="sidebar">
  <div class="d-flex align-items-center justify-content-between logo-rest">
    <a class="logo d-flex align-items-center">
      <img src="assets/img/RAYO NARANJA.png" alt="logo-haylli" />
    </a>
  </div>
  <ul class="sidebar-nav" id="sidebar-nav">
    <li class="nav-item">
      <a
        class="nav-link collapsed"
        data-bs-target="#ventas-nav"
        [class.active]="itemSelected(8)"
        data-bs-toggle="collapse"
        href="#"
      >
        <img
          class="image-black"
          src="assets/icon/Reservation.svg"
          alt="Reservation"
        />
        <img
          class="image-white"
          src="assets/icon/Reservation.svg"
          alt="Reservation"
        />
        <span>Ventas</span><i class="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul
        id="ventas-nav"
        class="nav-content collapse"
        data-bs-parent="#sidebar-nav"
      >
        <li
          *ngIf="
            userRoleStorage === 'ROLE_ADMIN' ||
            userRoleStorage === 'ROLE_WAITER' ||
            userRoleStorage === 'ROLE_CASHIER'
          "
        >
          <a
            href="#"
            [class.active]="itemSelected(0)"
            (click)="selectItem(0)"
            routerLink="/restaurant/table/list"
          >
            <img
              class="image-black"
              src="assets/icon/Serving Dish-white.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/Serving Dish-white.svg"
              alt="Reservation"
            />
            <span>Salones</span>
          </a>
        </li>
        <li
          *ngIf="
            userRoleStorage === 'ROLE_ADMIN' || userRoleStorage === 'ROLE_CHEF'
          "
        >
          <a
            href="#"
            [class.active]="itemSelected(1)"
            (click)="selectItem(1)"
            routerLink="/restaurant/commands/list"
          >
            <img
              class="image-black"
              src="assets/icon/reports-white.svg"
              alt="Pedidos"
            />
            <img
              class="image-white"
              src="assets/icon/reports-white.svg"
              alt="Pedidos"
            />
            <span>Comandas</span>
          </a>
        </li>
      </ul>
    </li>
    <li *ngIf="userRoleStorage === 'ROLE_ADMIN'" class="nav-item">
      <a
        class="nav-link collapsed"
        data-bs-target="#products-nav"
        data-bs-toggle="collapse"
        href="#"
      >
        <img
          class="image-black"
          src="assets/icon/Menu-white.svg"
          alt="Reservation"
        />
        <img
          class="image-white"
          src="assets/icon/Menu-white.svg"
          alt="Reservation"
        />
        <span>Catálogo</span><i class="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul
        id="products-nav"
        class="nav-content collapse"
        data-bs-parent="#sidebar-nav"
      >
        <li>
          <a
            #marca
            href="#"
            [routerLink]="['/restaurant/brand/list']"
            [class.active]="itemSelected(2)"
            (click)="selectItem(2)"
          >
            <img
              class="image-black"
              src="assets/icon/shop-white.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/shop-white.svg"
              alt="Reservation"
            />
            <span>Marcas</span>
          </a>
        </li>
        <li>
          <a
            #categoria
            href="#"
            routerLink="/restaurant/category/list"
            [class.active]="itemSelected(3)"
            (click)="selectItem(3)"
          >
            <img
              class="image-black"
              src="assets/icon/paste-white.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/paste-white.svg"
              alt="Reservation"
            />
            <span>Categorías</span>
          </a>
        </li>
        <li>
          <a
            href="#"
            routerLink="/restaurant/product/list"
            [class.active]="itemSelected(4)"
            (click)="selectItem(4)"
          >
            <img
              class="image-black"
              src="assets/icon/Food-white.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/Food-white.svg"
              alt="Reservation"
            />
            <span>Productos</span>
          </a>
        </li>
        <!-- <li>
          <a
            href="#"
            routerLink="/restaurant/product-type/list"
            [class.active]="itemSelected(5)"
            (click)="selectItem(5)"
          >
            <span>Tipo de Producto</span>
          </a>
        </li> -->
      </ul>
    </li>

    <li *ngIf="userRoleStorage === 'ROLE_ADMIN'" class="nav-item">
      <a
        class="nav-link collapsed"
        data-bs-target="#users-nav"
        data-bs-toggle="collapse"
        href="#"
      >
        <img
          class="image-black"
          src="assets/icon/chef-white.svg"
          alt="Reservation"
        />
        <img
          class="image-white"
          src="assets/icon/chef-white.svg"
          alt="Reservation"
        />
        <span>Usuarios/Locales</span><i class="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul
        id="users-nav"
        class="nav-content collapse"
        data-bs-parent="#sidebar-nav"
      >
        <li>
          <a
            #users
            href="#"
            [routerLink]="['/restaurant/user/list']"
            [class.active]="itemSelected(6)"
            (click)="selectItem(6)"
          >
            <img
              class="image-black"
              src="assets/icon/user-group-white.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/user-group-white.svg"
              alt="Reservation"
            />
            <span>Usuarios</span>
          </a>
        </li>
        <li>
          <a
            #location
            href="#"
            routerLink="/restaurant/location/list"
            [class.active]="itemSelected(7)"
            (click)="selectItem(7)"
          >
            <img
              class="image-black"
              src="assets/icon/locacion-white.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/locacion-white.svg"
              alt="Reservation"
            />
            <span>Establecimientos</span>
          </a>
        </li>
      </ul>
    </li>

    <li *ngIf="userRoleStorage === 'ROLE_ADMIN'" class="nav-item">
      <a
        class="nav-link collapsed"
        data-bs-target="#compras-nav"
        data-bs-toggle="collapse"
        href="#"
      >
        <img
          class="image-black"
          src="assets/icon/compras-white.svg"
          alt="Compras"
        />
        <img
          class="image-white"
          src="assets/icon/compras-white.svg"
          alt="Compras"
        />
        <span>Compras</span><i class="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul
        id="compras-nav"
        class="nav-content collapse"
        data-bs-parent="#sidebar-nav"
      >
        <li>
          <a
            #marca
            href="#"
            routerLink="/restaurant/shopping/create"
            [class.active]="itemSelected(2)"
            (click)="selectItem(2)"
          >
            <img
              class="image-black"
              src="assets/icon/compras-crear-blanco.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/compras-crear-blanco.svg"
              alt="Reservation"
            />
            <span>Nuevo</span>
          </a>
        </li>
        <li
          *ngIf="
            userRoleStorage === 'ROLE_ADMIN' || userRoleStorage === 'ROLE_CHEF'
          "
          class="nav-item"
        >
          <a
            #categoria
            href="#"
            routerLink="/restaurant/shopping/list"
            [class.active]="itemSelected(3)"
            (click)="selectItem(3)"
          >
            <img
              class="image-black"
              src="assets/icon/compras-listado-blanco.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/compras-listado-blanco.svg"
              alt="Reservation"
            />
            <span>Listado</span>
          </a>
        </li>
        <li
          *ngIf="
            userRoleStorage === 'ROLE_ADMIN' || userRoleStorage === 'ROLE_CHEF'
          "
          class="nav-item"
        >
          <a
            #categoria
            href="#"
            routerLink="/restaurant/shopping/person/list"
            [class.active]="itemSelected(4)"
            (click)="selectItem(4)"
          >
            <img
              class="image-black"
              src="assets/icon/truck-speed.svg"
              alt="Reservation"
            />
            <img
              class="image-white"
              src="assets/icon/truck-speed.svg"
              alt="Reservation"
            />
            <span>Proveedores</span>
          </a>
        </li>
        <li
          *ngIf="
            userRoleStorage === 'ROLE_ADMIN' || userRoleStorage === 'ROLE_CHEF'
          "
          class="nav-item"
        >
          <a
            #categoria
            href="#"
            routerLink="/restaurant/shopping/supplies/list"
            [class.active]="itemSelected(5)"
            (click)="selectItem(5)"
          >
            <i class="bi bi-cart-check" style="font-size: 20px;"></i>
            <span>Insumos</span>
          </a>
        </li>
      </ul>
    </li>
    <!-- Reportes -->
    <li class="nav-item">
      <a
        class="nav-link collapsed"
        data-bs-target="#reportes-nav"
        data-bs-toggle="collapse"
        href="#"
      >
        <img
          class="image-black"
          src="assets/icon/compras-white.svg"
          alt="Compras"
        />
        <img
          class="image-white"
          src="assets/icon/compras-white.svg"
          alt="Compras"
        />
        <span>Reportes</span><i class="bi bi-chevron-down ms-auto"></i>
      </a>
      <ul
        id="reportes-nav"
        class="nav-content collapse"
        data-bs-parent="#sidebar-nav"
      >
        <li>
          <a
            href="#"
            [class.active]="itemSelected(11)"
            (click)="selectItem(11)"
            routerLink="/restaurant/reports/list"
          >
            <img
              class="image-black"
              src="assets/icon/reports-white.svg"
              alt="Reportes de órdenes"
            />
            <img
              class="image-white"
              src="assets/icon/reports-white.svg"
              alt="Reportes de órdenes"
            />
            <span>Órdenes</span>
          </a>
        </li>
      </ul>
    </li>
  </ul>
</aside>
